/*
  ONDA — reveal leggero allo scroll.
  Vanilla JS, senza dipendenze da Horizon: aggiunge .onda-reveal (stato nascosto,
  vedi onda-scroll-reveal.css) agli elementi elencati sotto e li mostra con un
  IntersectionObserver quando entrano in viewport. Un solo passaggio per elemento
  (si "spegne" da solo dopo la rivelazione), rispetta prefers-reduced-motion e non
  fa nulla se manca IntersectionObserver.
*/
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var SELECTOR = [
    '.resource-list__item', // card prodotto (home / liste prodotto)
    '.product-grid__item', // griglia collezione
    '.club-story__media',
    '.club-story__content',
    '.onda-band__inner', // hero e banner (calendario, whatsapp)
    '.onda-contact__card',
    '.race-row', // righe calendario gare
    '.onda-tile' // tile di navigazione home (se in uso)
  ].join(',');

  var STAGGER_MS = 70;
  var MAX_STAGGER_STEPS = 6;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('onda-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -8% 0px' }
  );

  var groupCounts = new WeakMap();

  function prepare(root) {
    if (!root || !root.querySelectorAll) return;
    var els = root.querySelectorAll(SELECTOR);
    els.forEach(function (el) {
      if (el.classList.contains('onda-reveal')) return;
      var parent = el.parentElement;
      var index = groupCounts.get(parent) || 0;
      groupCounts.set(parent, index + 1);
      el.style.setProperty('--onda-reveal-delay', Math.min(index, MAX_STAGGER_STEPS) * STAGGER_MS + 'ms');
      el.classList.add('onda-reveal');
      observer.observe(el);
    });
  }

  prepare(document);

  // Copre anteprima Theme Editor, paginazione/infinite scroll e quick-add: rileva
  // nodi aggiunti al DOM dopo il primo giro e li prepara allo stesso modo.
  var scheduled = false;
  var mutationObserver = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      prepare(document);
    });
  });
  mutationObserver.observe(document.body, { childList: true, subtree: true });
})();
